const defaultDecimalValue = 2;

export function getPrecisionValue(value: string | undefined | null, uptoDecimal: number = defaultDecimalValue): string {
    if (value && isNaN(Number(value))) return value;
    return value ? Number(value).toFixed(uptoDecimal) : '';
}

export function getPrecisionNumber(
    value: string | undefined | null,
    uptoDecimal: number = defaultDecimalValue
): number | null {
    if (value && isNaN(Number(value))) return null;
    return value ? Number(Number(value).toFixed(uptoDecimal)) : null;
}
